import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/index";

const LOGIN = `
    login (login: $login, password: $password) {
		id
		first_name
		last_name
		email
		login
		token
		existed_role
		employee_id
		customer_id
		avatar(size: 80)
		preferences
		cluster_id
		role {
			id
			name
			gender
			phone
			email
			dob
			avatar(w: 100, h: 100)
			is_student
			properties
			cluster_id
			cluster {
				name
				company {
					name
					address
					logo (w: 90, h: 90)
				}
			}
			department {
				id
				name
				code
			}
			employee_points {
				id
				school_year
				semester
				course_point
				school_training_point
				dormitory_training_point
				files
				confirmed
				created_at
				updated_at
				attachs {
					id
					path
					file_name
					extension
				}
			}
			point_events {
				id
				school_year
				semester
				notes
				created_at
				updated_at
				point_event  {
					id
					name
					point
				}
			}
		}
    }
`;

const PERMISSIONS = `
	permissions (owner: $plugin_name) {
		key
		label
		owner
		allow
	}
`;

const REGISTER = `
	create_user (name: $name, login: $login, password: $password) {
		id
	}
`;

const REGISTER_COMPANY = `
	register_company (name: $name, email: $email, phone: $phone, functions: $functions)
`;

export default {
	init() {},

	login(email, pwd) {
		return graphqlClient
			.query({
				query: gql`query AccountManagement ($login: String!, $password: String!, $plugin_name: String) {
				${LOGIN}
				${PERMISSIONS}
			}`,
				variables: { login: email, password: pwd }
			})
			.then(response => {
				return {
					user: response.data.login || {},
					permissions: response.data.permissions
				};
			});
	},
	registerUser(name, email, pwd) {
		return graphqlClient.mutate({
			mutation: gql`mutation AccountManagement ($name: String!, $login: String!, $password: String!) {
				${REGISTER}
			}`,
			variables: {
				login: name,
				name: name,
				password: pwd
			}
		});
	},
	refreshToken() {},
	loadPermissions(payload) {
		return graphqlClient
			.query({
				query: gql`query AccountManagement ($plugin_name: String) {
				${PERMISSIONS}
			}`,
				variables: { plugin_name: payload.plugin || "" }
			})
			.then(response => {
				return {
					permissions: response.data.permissions
				};
			});
	},

	registerCompany(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation RegisterCompany ($name: String!, $email: String!, $phone: String!, $functions: [String] ) {
				${REGISTER_COMPANY}
			}`,
				variables: {
					phone: payload.phone || "",
					email: payload.email || "",
					name: payload.name || "",
					functions: payload.functions || []
				}
			})
			.then(response => {
				return {
					createCompany: response.data.create_company
				};
			});
	}
};
